import React from 'react';
import { TabPaneProps, TabPane as TabPaneComponent } from 'reactstrap';

const TabPane = (props: TabPaneProps) => (
  <TabPaneComponent {...props}></TabPaneComponent>
);
export default TabPane;
